import { cDatabaseApi, cDbQuery } from "./DatabaseApi";
import { cProjectApi } from "./ProjectApi";

export class cIModelApi {
  private static _imodel: Map<string,string>;

  public static async initIModelApi() {
    cDatabaseApi.initDatabaseApi("IModel");
  }


  public static async fetchIModels(project: string) {
    const q = new cDbQuery("IModel");
    q.setWhere("ProjectName", project);
    const dbRows = await cDatabaseApi.query(q);
    while(dbRows.next()){
      const rowMap: Map<string, string> = new Map();
      rowMap.set("imodelId", dbRows.getProperty("imodelId"));
      rowMap.set("Name", dbRows.getProperty("Name"));
      rowMap.set("ProjectName", dbRows.getProperty("ProjectName"));

      this._imodel = rowMap;
    }   
    return;
  }

  public static async getCurrentIModel(organization = "") {
    //await this.fetchIModels(organization);
    if (!this._imodel) {
      const projects = await cProjectApi.getProjects(organization);
      for (const project of projects) {
          if (project.get("Organization") === organization) {
            await this.fetchIModels(project.get("ProjectName") as string);
            return this._imodel;
          } 
      }
    }
    return this._imodel;
  }
}
